import $ from 'jquery';

function init() {
    const $unit = $('#unitSelect');
    if ($unit.length === 0) return;

    const $jobTitle = $('#jobTitleSelect');
    const $category = $('#tr-category');
    const $renewable = $('#tr-renewable');
    const $courseName = $('#tr-course-name');
    const $required = $('#tr-required');
    const $requiredWrapper = $('#tr-required-wrapper');
    const $viewAll = $('#trainingToolViewAll');
    const $results = $('#training-tool-results');
    const $reset = $('#trainingToolReset');
    const $filterSidebar = $('#training-filter-sidebar');
    const $resultsColumn = $('#training-results-column');
    const $resultsControls = $('#training-tool-controls');
    const noSelectionMessage = '<p class="text-muted">Select a department and job title above to see required and optional training.</p>';
    const spinnerHTML =
        `<div class="d-flex justify-content-center loading-spinner-container">
            <div class="spinner-border text-primary m-5" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>`;

    function showLoading() {
        $results.html(spinnerHTML);
    }

    function setRequiredFilterVisible(visible) {
        $requiredWrapper.toggleClass('d-none', !visible);
        if (!visible) $required.val('');
    }

    function setResultsControlsVisible(visible) {
        $filterSidebar.toggleClass('d-none', !visible);
        $resultsControls.toggleClass('d-none', !visible);
        $resultsColumn
            .toggleClass('col-md-9', visible)
            .toggleClass('col-12', !visible);
    }

    function applyFilters() {
        const categoryId = $category.val();
        const renewableOnly = $renewable.is(':checked');
        const requiredFilter = $required.val();
        const nameFilter = $courseName.val().trim().toLowerCase();

        $results.find('[data-section]').each(function () {
            const $section = $(this);
            const section = $section.data('section');
            const sectionVisible = !requiredFilter || requiredFilter === section;
            $section.toggleClass('d-none', !sectionVisible);
            if (!sectionVisible) return;

            let visibleCount = 0;
            $section.find('.accordion-item').each(function () {
                const $item = $(this);
                const itemCategories = ($item.data('categories') || '').toString().split(',').filter(Boolean);
                const matchesCategory = !categoryId || itemCategories.includes(categoryId);
                const matchesRenewable = !renewableOnly || $item.data('renewable') === 1;
                const title = ($item.data('title') || '').toString().toLowerCase();
                const matchesName = !nameFilter || title.includes(nameFilter);
                const visible = matchesCategory && matchesRenewable && matchesName;
                $item.toggleClass('d-none', !visible);
                if (visible) visibleCount++;
            });
            $section.toggleClass('d-none', visibleCount === 0);
        });
    }

    function updateDeepLinkUrl() {
        const unitSlug = $unit.find('option:selected').data('slug');
        const jobTitleSlug = $jobTitle.find('option:selected').data('slug');
        const url = unitSlug && jobTitleSlug
            ? `/training/unit/${unitSlug}/jobtitle/${jobTitleSlug}`
            : '/training';
        history.replaceState(null, '', url);
    }

    function loadJobTitleOptions(unitId) {
        $jobTitle.prop('disabled', true).html('<option value="">-Select a job title-</option>');

        if (!unitId) return $.Deferred().resolve([]).promise();

        return $.getJSON('/training/jobtitles', { unitId })
            .done(function (options) {
                options.forEach(function (option) {
                    $jobTitle.append($('<option>', { value: option.value, text: option.text, 'data-slug': option.slug }));
                });
                $jobTitle.prop('disabled', false);
            });
    }

    function selectUnit(unitId) {
        setRequiredFilterVisible(true);
        $unit.val(unitId || '');
        $results.html(noSelectionMessage);
        setResultsControlsVisible(false);
        updateDeepLinkUrl();
        return loadJobTitleOptions(unitId);
    }

    $unit.on('change', function () {
        selectUnit($(this).val());
    });

    $viewAll.on('click', function () {
        setRequiredFilterVisible(false);
        $unit.val('');
        $jobTitle.prop('disabled', true).html('<option value="">-Select a job title-</option>');

        showLoading();

        $.get('/training/all-courses')
            .done(function (html) {
                $results.html(html);
                applyFilters();
                setResultsControlsVisible($results.find('.accordion-item').length > 0);
                history.replaceState(null, '', '/training/all');
            });
    });

    $(document).on('component-autocomplete-selected-JobTitleSearchText', function (e, autocomplete) {
        const selected = autocomplete.selected;
        if (!selected || !selected.unitId) return;

        selectUnit(selected.unitId).done(function () {
            if (selected.jobTitleId) {
                $jobTitle.val(selected.jobTitleId).trigger('change');
            }
        });
    });

    $jobTitle.on('change', function () {
        const jobTitleId = $(this).val();
        updateDeepLinkUrl();

        if (!jobTitleId) {
            $results.html(noSelectionMessage);
            setResultsControlsVisible(false);
            return;
        }

        showLoading();

        $.get('/training/courses', { jobTitleId })
            .done(function (html) {
                $results.html(html);
                applyFilters();
                setResultsControlsVisible($results.find('.accordion-item').length > 0);
            });
    });

    $category.on('change', applyFilters);
    $renewable.on('change', applyFilters);
    $required.on('change', applyFilters);
    $courseName.on('input', applyFilters);

    $('#trainingToolExpandAll').on('click', function () {
        $results.find('[data-section]:not(.d-none) .accordion-item:not(.d-none)').each(function () {
            $(this).find('.accordion-collapse').addClass('show');
            $(this).find('.accordion-button').removeClass('collapsed').attr('aria-expanded', 'true');
        });
    });

    $('#trainingToolCollapseAll').on('click', function () {
        $results.find('[data-section]:not(.d-none) .accordion-item:not(.d-none) .accordion-collapse').removeClass('show');
        $results.find('[data-section]:not(.d-none) .accordion-item:not(.d-none) .accordion-button').addClass('collapsed').attr('aria-expanded', 'false');
    });

    $reset.on('click', function () {
        setRequiredFilterVisible(true);
        $unit.val('');
        $category.val('');
        $renewable.prop('checked', false);
        $courseName.val('');
        $jobTitle.prop('disabled', true).html('<option value="">-Select a job title-</option>');
        $results.html(noSelectionMessage);
        setResultsControlsVisible(false);
        history.replaceState(null, '', '/training');
    });
}

$(document).on('page-init-complete', init);
